import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { API_SERVICE_BACKEND } from "src/config";

const CancelSubModal = ({
  isStripePaidUser,
  getAllWhiteLabelClients,
  closeSubscriptionDetailModal,
  setOpen,
  open,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setOpen({ open: false, data: null });
  };

  const handleCancelSubscription = async () => {
    const requestData = {
      userEmail: open?.data?.white_label_plans?.userEmail,
      whiteLabelUserId: open?.data?.whiteLabelUserId,
      subscriptionId: open?.data?.white_label_plans?.subscriptions?.base?.id,
    };

    try {
      setIsLoading(true);
      await axios.post(
        `${API_SERVICE_BACKEND}/cancelWhiteLabelUserSubscription`,
        requestData
      );

      if (isStripePaidUser) {
        toast.success(
          "Subscription will be canceled at the end of the period."
        );
      } else {
        getAllWhiteLabelClients();
        toast.success("Subscription cancelled successfully.");
      }
      closeSubscriptionDetailModal();
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open.open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Cancel Subscription?</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent sx={{ py: 1 }}>
        <Typography variant="subtitle1" gutterBottom>
          {isStripePaidUser
            ? `All subscriptions will stay active until the end of the billing cycle,
          then be auto-cancelled and deleted. Are you sure you want to proceed?`
            : `All subscriptions will be cancelled immediately and the user access will be revoked. Are you sure you want to proceed?`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" variant="outlined" className="glass-button-secondary-50">
          Close
        </Button>
        <Button
          onClick={handleCancelSubscription}
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress color="inherit" size={25} />
          ) : (
            "Yes, Cancel"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelSubModal;
